(() => {
  // app/scripts/common/component/details.js
  !window.customElements.get("accordion-component") && window.customElements.define("accordion-component", class extends HTMLElement {
    constructor() {
      super();
      this._timeoutId = setTimeout(() => {
        if (this.querySelector(".jsNavContent, details")) {
          this.init();
        }
      }, 0);
    }
    disconnectedCallback() {
      if (this._timeoutId) {
        clearTimeout(this._timeoutId);
      }
      this._removeEventListeners();
    }
    _removeEventListeners() {
      if (this.summary) {
        this.summary.removeEventListener("click", this._onClickBound);
      }
      if (this.close) {
        this.close.removeEventListener("click", this._onClickBound);
      }
    }
    init() {
      this.details = this.querySelector("details, .jsDetails");
      if (!this.details)
        return;
      this.summary = this.details.querySelector(".jsNav, :scope > summary");
      this.close = this.details.querySelector(".js-details-close");
      this.content = this.details.querySelector(".jsNavContent, :scope > *:not(summary)");
      if (!this.summary || !this.content)
        return;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this._onClickBound = this.onClick.bind(this);
      this.summary.addEventListener("click", this._onClickBound);
      if (this.close && this.close.closest("details") === this.details) {
        this.close.addEventListener("click", this._onClickBound);
      }
      this.details.classList.add("accordion-initialized");
      if (this.details.tagName !== "DETAILS") {
        this.details.setOpen = false;
      }
    }
    onClick(e) {
      if (e.target.closest(".jsAccordionPrevent")) {
        e.preventDefault();
        return;
      }
      if (!this.details || this.hasAttribute("data-disabled"))
        return;
      this.details.style.overflow = "hidden";
      if (this.isClosing || !this.details.setOpen) {
        this.open();
      } else if (this.isExpanding || this.details.setOpen) {
        this.shrink();
      }
    }
    toggle(callback = null) {
      if (!this.details)
        return;
      if (this.isClosing || !this.details.setOpen) {
        this.open(callback);
      } else if (this.isExpanding || this.details.setOpen) {
        this.shrink(callback);
      }
    }
    shrink(callback = null) {
      if (!this.details || !this.summary)
        return;
      this.isClosing = true;
      const summaryPosition = window.getComputedStyle(this.summary).position;
      const startHeight = `${this.details.offsetHeight}px`;
      const endHeight = `${summaryPosition === "absolute" ? 0 : this.summary.offsetHeight}px`;
      if (this.animation) {
        this.animation.cancel();
      }
      this.details.classList.add("is-closing");
      this.animation = this.details.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: "ease-out"
      });
      this.animation.onfinish = () => {
        this.onAnimationFinish(false);
        if (callback)
          callback();
      };
      this.animation.oncancel = () => {
        this.isClosing = false;
      };
    }
    open(callback = null) {
      if (!this.details || !this.summary || !this.content)
        return;
      this.details.style.height = `${this.details.offsetHeight}px`;
      this.details.setOpen = true;
      this.details.classList.add("is-opening");
      this.isExpanding = true;
      const summaryPosition = window.getComputedStyle(this.summary).position;
      const summaryHeight = summaryPosition === "absolute" ? 0 : this.summary.offsetHeight;
      const startHeight = `${this.details.offsetHeight}px`;
      const endHeight = `${summaryHeight + this.content.offsetHeight}px`;
      if (this.animation) {
        this.animation.cancel();
      }
      this.animation = this.details.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: "ease-out"
      });
      this.animation.onfinish = () => {
        this.onAnimationFinish(true);
        if (callback)
          callback();
      };
      this.animation.oncancel = () => {
        this.isExpanding = false;
      };
    }
    onAnimationFinish(open) {
      if (!this.details)
        return;
      this.details.setOpen = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.details.classList.remove("is-closing", "is-opening");
      this.details.style.height = "";
      this.details.style.overflow = "";
    }
  });
})();
